import { Button } from "primereact/button";
import { Stepper } from "primereact/stepper";
import { StepperPanel } from "primereact/stepperpanel";
import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const UploadDocumenthtml = () => {
  return (
    <div>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="edit-ticket mb-4">
            <div className="w-100">
              <div className="row justify-content-center">
                <div className="col-lg-9">
                  <div className="Upload-user-profile-bx">
                    <div className="me-auto">
                      <h2 className="font-w600 mb-0">Upload Employees</h2>
                    </div>
                    <div className="addnew-assessmentform flex justify-content-center add-assessment-uploadform">
                      <Stepper
                        className="disable-step-click"
                        style={{ flexBasis: "50rem" }}
                      >
                        <StepperPanel header="Upload">
                          <div className="flex flex-column h-12rem">
                            <div className="Upload-user-profile-bx">
                              <div className="text-center">
                                <h2>Upload Employees</h2>
                                <p className="description">
                                  Before you upload your files below, make sure
                                  your file is
                                  <span className="highlight"> correct</span>.
                                  OrgGenie will let you know when your records
                                  <span className="highlight">duplicates</span>
                                  or
                                  <span className="highlight"> invalid</span>.
                                </p>
                              </div>
                              <div className="import-section mt-3">
                                <h3>Import file</h3>
                                <div
                                  className="upload-box"
                                  style={{
                                    cursor: "pointer",
                                    border: "2px dashed #ccc",
                                    padding: "11px",
                                    textAlign: "center",
                                  }}
                                >
                                  <div
                                    className="upload-icon"
                                    style={{ fontSize: "2rem" }}
                                  >
                                    👤
                                  </div>
                                  <p className="mb-0">
                                    Drag and drop or
                                    <span
                                      style={{
                                        color: "blue",
                                        textDecoration: "underline",
                                      }}
                                    ></span>
                                    to upload your Employees.
                                    <br />
                                    All .csv, .xlsx, and .xls file types are
                                    supported.
                                  </p>
                                  <input
                                    type="file"
                                    accept=".csv,.xlsx,.xls"
                                    style={{ display: "none" }}
                                  />
                                </div>
                                <div className="mt-2">
                                  <a
                                    //  href={downloadExcelExample}
                                    className="example-link text-end"
                                    target="blank"
                                    download
                                  >
                                    Download Template file
                                  </a>
                                </div>
                                <div className="or-section">
                                  <span>OR</span>
                                </div>
                                <Link
                                  to="/Employee/Add"
                                  className="btn btn-block btn-danger "
                                >
                                  Enter Employee Details Individually
                                </Link>
                              </div>
                              <div className="import-section mt-3">
                                <div
                                  className="upload-box"
                                  style={{
                                    border: "2px dashed #ccc",
                                    padding: "20px",
                                    textAlign: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      position: "relative",
                                      display: "Block",
                                    }}
                                  >
                                    <div className="mb-2 ">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        fill="currentColor"
                                        className="bi bi-filetype-pdf"
                                        viewBox="0 0 16 16"
                                      >
                                        <path
                                          fill-rule="evenodd"
                                          d="M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5zM1.6 11.85H0v3.999h.791v-1.342h.803q.43 0 .732-.173.305-.175.463-.474a1.4 1.4 0 0 0 .161-.677q0-.375-.158-.677a1.2 1.2 0 0 0-.46-.477q-.3-.18-.732-.179m.545 1.333a.8.8 0 0 1-.085.38.57.57 0 0 1-.238.241.8.8 0 0 1-.375.082H.788V12.48h.66q.327 0 .512.181.185.183.185.522m1.217-1.333v3.999h1.46q.602 0 .998-.237a1.45 1.45 0 0 0 .595-.689q.196-.45.196-1.084 0-.63-.196-1.075a1.43 1.43 0 0 0-.589-.68q-.396-.234-1.005-.234zm.791.645h.563q.371 0 .609.152a.9.9 0 0 1 .354.454q.118.302.118.753a2.3 2.3 0 0 1-.068.592 1.1 1.1 0 0 1-.196.422.8.8 0 0 1-.334.252 1.3 1.3 0 0 1-.483.082h-.563zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638z"
                                        />
                                      </svg>
                                    </div>
                                  </div>
                                  <div className="position-relative hover-block-area">
                                    <span className="btn btn-danger cross-btn-all small-rounded-cross">
                                      ×
                                    </span>
                                    <p className=" d-inline">
                                      <span
                                        style={{
                                          color: "blue",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        <br />
                                        choose Other file{" "}
                                      </span>
                                    </p>
                                  </div>
                                  <input
                                    type="file"
                                    accept=".csv,.xlsx,.xls"
                                    style={{ display: "none" }}
                                  />
                                </div>
                                <a
                                  href="/OrgEmployee_Upload.xlsx"
                                  className="example-link text-end"
                                  download
                                >
                                  Download example file
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="flex pt-3 justify-content-between text-right">
                            <div>
                              <Button
                                severity="secondary"
                                className="btn btn-danger "
                              >
                                Enter Employee Details Individually
                              </Button>

                              <Button
                                label="Next"
                                className="publish-click w-auto"
                              />
                            </div>
                          </div>
                        </StepperPanel>
                      </Stepper>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UploadDocumenthtml;
